import type {Component, Editor} from 'grapesjs';
import type {ConditionalInfoBoxDescriptor} from '../info-box-control/info-box-control.types';

export const VIDEO_MEDIA_EXTENSIONS: readonly string[] = ['mp4', 'webm', 'mov'];

export interface UploadButtonDescriptor {
  labelKey: string;
  /** CSS property read for the initial preview URL; when omitted no preview is read from style. */
  property?: string;
  /** Must open the media picker and call onMediaSelected with the chosen URL on confirm. */
  onUpload: (editor: Editor, component: Component, onMediaSelected: (url: string) => void) => void;
  onClear: (editor: Editor, component: Component) => void;
  warning?: ConditionalInfoBoxDescriptor;
}
